module.exports = __webpack_public_path__ + "img/uploadIcon.69db90cf.svg";